class CartWatcher {

    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
      });
    }
  
    async fetchCart() {
      const response = await fetch('/cart.js');
      return response.json();
    }
  
    storeCart(cart) {
      localStorage.setItem('cart', JSON.stringify(cart));
    }
  
   storedCart() {
      return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }
  
   findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
      };
  
      oldCart.items.forEach(oi => {
        const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
        if (!ni) return;
        let quantity = ni.quantity - oi.quantity;
        let item = { ...ni };
        item.quantity = Math.abs(quantity);
        quantity > 0
          ? result.added.push(item)
          : result.removed.push(item)
      });
  
      return result;
    }
  
    async emitCartChanges() {
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();
      const changes = this.findCartChanges(oldCart, newCart);
  
      const event = new CustomEvent("cart_changed", { detail: changes });
      document.dispatchEvent(event);
  
      this.storeCart(newCart);
    }
  
    observeCartChanges() {
      let debounceTimeout;
      const debounceEmitCartChanges = () => {
          clearTimeout(debounceTimeout);
          debounceTimeout = setTimeout(() => {
              this.emitCartChanges();
          }, 200);
      };
  
      const cartObserver = new PerformanceObserver((list) => {
          list.getEntries().forEach((entry) => {
              const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
              const isCartChangeRequest = /\/cart\//.test(entry.name);
              if (isValidRequestType && isCartChangeRequest) {
                  debounceEmitCartChanges();
              }
          });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }
  
}